import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { CONSTANTS } from "../config/constants";
import * as moment from "moment";
import { LocalStorageService } from "./local-storage.service";
import { Router } from "@angular/router";
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  BASE_URL: any = "";
  translate: any;

  sideBarToggle = new EventEmitter<Boolean>();

  constructor(
    private httpClient: HttpClient,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {
    this.BASE_URL = environment.BASE_URL;
    this.translate = this.translateService;
    this.translateServiceInit();
  }

  getAPICall(): Observable<any> {
    return this.httpClient.get(this.BASE_URL + "/posts").pipe(
      tap((result: Response) => {
        return result;
      }),
      catchError((error) => {
        this.toasterService(0, "Something Went Wrong!");
        return error;
      })
    );
  }

  toasterService(code, msg) {
    if (code == 1) {
      this.toastr.success(msg);
      /*this.toastr.success(msg,
        '' , {
                 enableHtml: true,
                 closeButton: true,
                 timeOut: 100000,
                 disableTimeOut: true
             });*/
    } else if (code == 2) {
      this.toastr.warning(msg);
    } else {
      this.toastr.error(msg);
      /*this.toastr.error(msg,
      '' , {
               enableHtml: true,
               closeButton: true,
               timeOut: 100000,
               disableTimeOut: true
           });*/
    }
  }

  translateServiceInit() {
    this.translateService.addLangs(["en", "fr"]);
    this.translateService.setDefaultLang("en");

    const browserLang = this.translateService.getBrowserLang();
    this.translateService.use(browserLang.match(/en|fr/) ? browserLang : "en");
    console.log("=====done=====");
  }

  changeLanguage(lang) {
    this.translate.use(lang);
    console.log("==========Language changed!");
  }

  getRegex() {
    return {
      email: /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,4}$/,
      username: /^[a-zA-Z0-9.]*$/,
      number: /^(?=.*?[0-9])/,
      lowercase: /^(?=[^a-z]*[a-z])/,
      uppercase: /^(?=[^A-Z]*[A-Z])/,
      special: /^(?=.*?[#?!@$%^&*-])/,
    };
  }

   emailValidator(): ValidatorFn {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return (control: AbstractControl): ValidationErrors | null => {
      const emails = control.value;
      let finalEmail = []
      emails.map((indvEmail) => {
        if (indvEmail.label) {
          finalEmail.push(indvEmail.label)
        }else{
          finalEmail.push(indvEmail)
        }
      });
      console.log("emailssssss",finalEmail)

      if (Array.isArray(finalEmail)) {
        for (let email of finalEmail) {
          console.log("email", email);
          if (!emailPattern.test(email)) {
            return { invalidEmail: true };
          }
        }
      }
      return null;
    };
  }

  onlyBlankSpacesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string;
      const isValid = /^[\s]*$/.test(value);
      return isValid ? { onlyBlankSpaces: true } : null;
    };
  }

  toggleSideBar() {
    this.sideBarToggle.emit();
  }

  /**
   * Get lookup data
   * @returns
   */
  getLookupData(groupedValues = false): Observable<any> {
    return this.httpClient.get(
      CONSTANTS.APP.BASE_API_URL_METADATA +
        CONSTANTS.API.ROUTE.METADATA.LOOKUP +
        "?grouped_values=" +
        groupedValues
    );
  }

  getLookupDataWithKey(key): Observable<any> {
    return this.httpClient.get(
      CONSTANTS.APP.BASE_API_URL_METADATA +
        CONSTANTS.API.ROUTE.METADATA.LOOKUP +
        `?key=${key}`
    );
  }

  /**
   * filter data from array
   * @param arr
   * @param keyName
   * @param keyValue
   * @returns
   */
  filterArrayData(arr, keyName: any, keyValue: any, ObjValues = 0) {
    if (ObjValues == 1) {
      let objValues = Object.values(arr);
      return objValues.filter((x) => x[keyName] === keyValue);
    } else {
      return arr.filter((x) => x[keyName] === keyValue);
    }
  }

  /**
   * validate email address
   * @param inputText
   * @returns
   */
  validateEmail(inputText) {
    var mailformat = this.getRegex().email;
    if (inputText.match(mailformat)) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * function to Handle API response i.e success
   * @param response
   * @returns
   */
  handleSubscribeNext(response: any) {
    var statuscode = Number(response.code);
    switch (statuscode) {
      case CONSTANTS.API.RESPONSE.STATUS_CODE.UNAUTHORIZED:
        this.toasterService(0, "UNAUTHORIZED");
        // console.log(CONSTANTS.API.RESPONSE.STATUS_CODE.UNAUTHORIZED + " Case Unauthorized - redirect to login");
        //this.router.navigateByUrl("/login");
        break;
      case CONSTANTS.API.RESPONSE.STATUS_CODE.SUCCESS:
        // console.log(CONSTANTS.API.RESPONSE.STATUS_CODE.SUCCESS + ' Case Success Executed');
        break;
      case CONSTANTS.API.RESPONSE.STATUS_CODE.ERROR:
        if (
          response.error ==
          CONSTANTS.API.RESPONSE.STATUS_MESSAGE.JWT_TOKEN_EXPIRED
        ) {
          this.localStorageService.signOut();
          this.router.navigate(["login"]).then(() => {});
          break;
        }
        // console.log(CONSTANTS.API.RESPONSE.STATUS_CODE.SUCCESS + ' Case Success Executed');
        this.toasterService(0, response.error);
        break;
      default:
        //this.toastService.showError("Service Temporarily Unavailable!");
        break;
    }
    return statuscode;
  }

  /**
   * function to Handle API response i.e error
   * @param e
   */
  handleSubscribeError(e: any = {}) {
    if (e && e.error) {
      switch (e.error.code) {
        case CONSTANTS.API.RESPONSE.STATUS_CODE.UNAUTHORIZED:
          // this.router.navigateByUrl("/login");
          break;
        case CONSTANTS.API.RESPONSE.STATUS_CODE.ERROR:
          //this.toastService.showError(e.error.error.message);
          break;
        case undefined:
         // console.log("Case undefined - API Service Temporarily Unavailable!");
          this.toasterService(0, "There seems to be some technical error. Please try again.");

          // this.toastService.showError('API Service Temporarily Unavailable!');
          break;
        default:
          console.log(`Case default - ${e.error.code}`);
          // this.toastService.showError(e.error.statusCode+" : Service Temporarily Unavailable!");
          break;
      }
    }
    return e ? e.error : 500;
  }

  /**
   * allow number only
   * @param event
   * @returns
   */
  numberOnly(event) {
    if (event.type == "keyup" && /\D/g.test(event.target.value)) {
      event.target.value = event.target.value.replace(/\D/g, "");
    } else if (event.type == "paste") {
      var text = (event.originalEvent || event).clipboardData.getData(
        "text/plain"
      );
      var trimText = text.replace(/\D/g, "");
      event.clipboardData.setData("text/plain", trimText);
      event.preventDefault();
      document.execCommand("insertHTML", false, trimText);
    } else if (
      event.type == "keypress" &&
      /\D/g.test(event.target.value) == false
    ) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
    /*const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;*/
  }

  numberOnlyPaste(input) {
    let value = input.value;
    return value.replace(/[^0-9]/g, "");
  }

  /**
   * number with decimal
   * @param event
   * @returns
   */
  numberWithDecimalOnly(event): boolean {
    if (event.type == "keyup") {
      event.target.value = event.target.value.replace(/[^\d.]/g, "");
    } else if (event.type == "paste") {
      var text = (event.originalEvent || event).clipboardData.getData(
        "text/plain"
      );
      var trimText = text.replace(/[^\d.]/g, "");
      event.clipboardData.setData("text/plain", trimText);
      event.preventDefault();
      document.execCommand("insertHTML", false, trimText);
    } else if (
      event.type == "keypress" &&
      /[^\d.]/g.test(event.target.value) == false
    ) {
      const charCode = event.which ? event.which : event.keyCode;
      if (
        (charCode != 46 || event.target.value.indexOf(".") != -1) &&
        (charCode < 48 || charCode > 57)
      ) {
        return false;
      }
      return true;
    }
  }

  // Old Function
  // numberWithDecimalOnly(event): boolean {
  //   const charCode = (event.which) ? event.which : event.keyCode;
  //   if ((charCode != 46 ||event.target.value.indexOf('.') != -1) && (charCode < 48 || charCode > 57)){
  //     return false;
  //   }
  //   return true;
  // }

  /**
   * allow backspace and delete only
   * @param e
   * @returns
   */
  allowDeleteOnly(e) {
    var charCode = e.keyCode || e.which;
    if (charCode == 8 || charCode == 46) {
      return true;
    }
    return false;
  }

  /**
   * get string first char
   * @param string
   */
  getStringFirstChar(string, countFullString = 0) {
    if (string == null) {
      return "";
    }
    let splitArr = string.split(" ");
    var result = "";
    var totalLength =
      countFullString == 0
        ? splitArr.length > 1
          ? 1
          : splitArr.length
        : splitArr.length;
    var stringLen = totalLength > 2 ? 2 : totalLength;
    for (let i = 0; i < stringLen; i++) {
      result += splitArr[i].charAt(0).toUpperCase();
    }
    return result;
  }

  getAdditionalChargesStr(data) {
    let knet = "",
      cc = "",
      ew = "";
    let adc = data;
    let arr = [];
    let last;
    if (adc.knet_charge) {
      if(adc.knet_charge_type == 1){
        knet = `${adc.knet_charge_type == 1 ? "KWD" : ""} ${parseFloat(adc.knet_charge).toFixed(3)} on KNET`
      }else if(adc.knet_charge_type == 0){
        knet = `${parseFloat(adc.knet_charge).toFixed(0)}${adc.knet_charge_type == 0 ? "%" : ""} on KNET`
      }
      arr.push(knet);
    }
    if (adc.credit_card_charge) {
      if(adc.credit_card_charge_type == 1){
        cc = `${adc.credit_card_charge_type == 1 ? "KWD" : ""} ${parseFloat(
          adc.credit_card_charge
        ).toFixed(3)} on Credit Card`;
      }else if(adc.credit_card_charge_type == 0){
        cc = `${parseFloat(
          adc.credit_card_charge
        ).toFixed(0)}${
          adc.credit_card_charge_type == 0 ? "%" : ""
        } on Credit Card`;
      }
      
      arr.push(cc);
    }
    if (adc.e_wallet_charge) {
      if(adc.e_wallet_charge_type == 1){
        ew = `${adc.e_wallet_charge_type == 1 ? "KWD" : ""} ${parseFloat(
          adc.e_wallet_charge
        ).toFixed(3)} on E-Wallet`;
      }else if(adc.e_wallet_charge_type == 0){
        ew = `${parseFloat(
          adc.e_wallet_charge
        ).toFixed(0)}${adc.e_wallet_charge_type == 0 ? "%" : ""} on E-Wallet`;
      }
      
      arr.push(ew);
    }
    if (arr.length == 1) {
      return arr;
    } else {
      last = arr.pop();
      return arr.join(" , ") + " and " + last;
    }
  }

  /**
   * get country list
   * @param requestData
   * @returns
   */
  getCountryList(): Observable<any> {
    return this.httpClient.get(
      CONSTANTS.APP.BASE_API_URL_METADATA + CONSTANTS.API.ROUTE.METADATA.COUNTRY
    );
  }

  /**
   * get state list
   * @param countryId
   * @returns
   */
  getStateList(countryId): Observable<any> {
    return this.httpClient.get(
      CONSTANTS.APP.BASE_API_URL_METADATA +
        CONSTANTS.API.ROUTE.METADATA.STATE +
        "?country_id=" +
        countryId
    );
  }

  /**
   * get city list
   * @param stateId
   * @returns
   */
  getCityList(stateId): Observable<any> {
    return this.httpClient.get(
      CONSTANTS.APP.BASE_API_URL_METADATA +
        CONSTANTS.API.ROUTE.METADATA.CITY +
        "?state_id=" +
        stateId
    );
  }

  //**CUSTOMER, PRODUCT */
  /**
   *  Date format for displying in the front end
   * @param date
   * @returns
   */
  formatDisplayDate(date, time = 0) {
    if (time == 1) {
      return moment(date).format("DD/MM/YYYY hh:mm a");
    } else {
      return moment(date).format("DD/MM/YYYY");
    }
  }

  /**
   * Date format for API calls
   * @param date
   * @returns
   */
  formatApiDate(date) {
    return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
  }
  /**
   *
   * @param text allows only arabic characters
   * @returns
   */

  isArabicChars(event) {
    var arregex = new RegExp("^[\u0621-\u064A\u0660-\u0669 ]+$");
    if (event.type == "paste") {
      var text = (event.originalEvent || event).clipboardData.getData(
        "text/plain"
      );
      return arregex.test(text);
    } else if (event.type == "keypress") {
      return arregex.test(event.key);
    }
  }

  maxLength(text, number) {
    if (JSON.parse(text.key) > 0 && JSON.parse(text.key) <= number) {
      return text.key;
    } else {
      return false;
    }
  }

  roundOfToFiveDigitsAndThreeDecimalsDigits(event) {
    const reg = /^\d{0,5}(\.\d{0,3})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);
    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  dateOnlyNumberAndSlash(event) {
    const reg = /[0-9\/]/;
    let input = event.key;
    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  sixDigitsAndTwoDecimals(event) {
    const reg = /^\d{0,6}(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);
    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  fiveDigitsAndTwoDecimals(event) {
    const reg = /^\d{0,5}(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);
    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  alphabetsNumbersAndDashed(event) {
    if (event.type == "paste") {
      var text = (event.originalEvent || event).clipboardData.getData(
        "text/plain"
      );
      var trimText = text.replace(/[^a-zA-Z0-9-]/gi, "");
      event.clipboardData.setData("text/plain", trimText);
      event.preventDefault();
      document.execCommand("insertHTML", false, trimText);
    } else if (event.type == "keypress") {
      const reg = /^[a-zA-Z0-9-]*$/;
      let input = event.key;
      if (!reg.test(input)) {
        event.preventDefault();
      }
    }
  }

  bracketsNotAllowed(event) {
    var arregex = new RegExp("^[^()]*$");
    if (event.type == "paste") {
      var text = (event.originalEvent || event).clipboardData.getData(
        "text/plain"
      );
      return arregex.test(text);
    } else if (event.type == "keypress") {
      return arregex.test(event.key);
    }
  }

  /**
   * convert to UTC time
   * @param dateTime
   */
  convertToUTCTime(dateTime) {
    //console.log(dateTime)
    //return new Date(dateTime).toUTCString()
    return moment(dateTime).utc().format();
  }

  /***
   * format kyc durations
   */
  formatKycDuration(date) {
    var hoursDiff = moment().diff(moment(date), "hours");
    if (hoursDiff > 24) {
      var days = Math.floor(hoursDiff / 24);
      var remainder = hoursDiff % 24;
      var hours = Math.floor(remainder);
      return days + " day(s) " + hours + " hour(s) ";
    }
    return hoursDiff + " hour(s) ";
  }
  lumiance(color) {
    // console.log("luma", color)
    let rgb = this.hextoRgb(color);
    // console.log('==========rgb', rgb);
    let luma = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    // console.log(luma);
    return luma > 0.5 ? "#000000" : "#FFFFFF";
  }
  hextoRgb = (color) => {
    const r = parseInt(color.substr(1, 2), 16);
    const g = parseInt(color.substr(3, 2), 16);
    const b = parseInt(color.substr(5, 2), 16);
    let rgb = { r: r, g: g, b: b };
    return rgb;
  };
  componentToHex(c) {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

    rgbToHex(r, g, b) {
      console.log("rgb",r,g,b)
    return (
      "#" +
      this.componentToHex(r) +
      this.componentToHex(g) +
      this.componentToHex(b)
    );
  }
}
